export default {
  "___ari_page-title": "",
  "ari_title_your-ari": "Your Authorizations",
  "ari_page-description": "Authorize a person(s) to receive information on your account when they call Customer Service. This authorization will remain in effect until the expiration date.",
  "ari_action_add-ari": "Add an Authorization",
  "___ari_label_name": "",
  "ari_label_expiration-date": "Expiration Date",
  "___ari_label_action": "",
  "___ari_action_edit-ari": "",
  "___ari_action_remove-ari": "",
};